<template>
    <q-list class="text-grey-3 q-pt-sm">
        <template v-for="(menu, index) in admin_menu" :key="index">
            <template v-if="is_view(menu)">
            <q-expansion-item group="menu" class="left_menu pb2" expand-separator :class="{active:menu.is_selected}"
                            :icon="menu.icon" :label="menu.title" v-model="menu.is_selected"
                            @click="goto_link(menu)" >
                <q-item clickable v-ripple @click="goto_link(item)" 
                        v-for="(item, i) in menu.children" :key="index+'.'+i">
                    <q-item-section avatar></q-item-section>
                    <q-item-section> {{ item.title }} </q-item-section>
                    <template v-if="item.children.length>0">
                        <q-item-section side >
                            <q-icon name="keyboard_arrow_right" ></q-icon>
                        </q-item-section>
                        <admin-left-pop-menu :menu="item" :key-index="''+i" ></admin-left-pop-menu>
                    </template>
                </q-item>
            </q-expansion-item>
            </template>
        </template>
        <template v-for="(menu, index) in system_menu" :key="index">
            <template v-if="is_view(menu)">
            <q-expansion-item group="menu" class="left_menu pb2" expand-separator :class="{active:menu.is_selected}"
                            :icon="menu.icon" :label="menu.title" v-model="menu.is_selected"
                            @click="goto_link(menu)" >
                <q-item clickable v-ripple @click="goto_link(item)" 
                        v-for="(item, i) in menu.children" :key="index+'.'+i">
                    <q-item-section avatar></q-item-section>
                    <q-item-section> {{ item.title }} </q-item-section>
                    <template v-if="item.children.length>0">
                        <q-item-section side >
                            <q-icon name="keyboard_arrow_right" ></q-icon>
                        </q-item-section>
                        <admin-left-pop-menu :menu="item" :key-index="''+i" ></admin-left-pop-menu>
                    </template>
                </q-item>
            </q-expansion-item>
            </template>
        </template>
    </q-list>
</template>

<script>
import adminLeftPopMenu from "./adminLeftPopMenu.vue"

export default {
    components : {
        adminLeftPopMenu,
    },
    data() {
        return {
            admin_menu : [
                    { title : '대시보드', icon : 'dashboard', is_selected: false,
                        route:"dashboard",
                        link : 'dashboard', children: [] },
                    { title : '상품관리', icon : 'shopping_cart', is_selected: false,
                        route:"catalog",
                        link : '', children: [
                        ] },
                    { title : '판매', icon : 'fact_check', is_selected: false,
                        route:"order",
                        link : '', children: [
                        ] },
                    { title : '마케팅', icon : 'storefront', is_selected: false,
                        route:"communication",
                        link : '', children: [
                        { title : '문의하기', link : 'communication/contact', children: [] },
                        ] },
                    { title : '페이지설정', icon : 'task', is_selected: false,
                        route:"page",
                        link : '', children: [
                        ] },
            ],
            system_menu : [
                    { title : '관리자', icon : 'settings', is_selected: false,
                        route:"system",
                        link : '', children: [
                        { title : '관리자', link : 'system/admin/admin', children: [] },
                        { title : '관리자그룹', link : 'system/admin/admin_group', children: [] },
                        ] },
            ],
        }
    },
    computed : {
        admin() {
            return this.$store.state.admin;
        },
        permission() {
            return this.$store.state.permission;
        },
    },
    methods : {
        is_view(menu) {
            let key = menu.route;
            if( this.$store.state.admin.admin_group_id==1) { return true; }
            if(this.$c.hasProperty(this.permission, key)===true) {
                return this.permission[key].view==1;
            }
            return false;
        },

        link_prefix() {
            return '/admin/app/aca_erp/';
        },
        leftMenu_click : function(route) {
            var i;
            for(i=0; i<this.admin_menu.length; i++) {
                let menu_route = this.link_prefix() + this.admin_menu[i].route;
                if( route.startsWith(menu_route)) {
                    this.admin_menu[i].is_selected= !this.admin_menu[i].is_selected;
                } else {
                    this.admin_menu[i].is_selected = false;
                }
            }
            for(i=0; i<this.system_menu.length; i++) {
                let menu_route = this.link_prefix()  + this.system_menu[i].route;
                if( route.startsWith(menu_route)) {
                    this.system_menu[i].is_selected= !this.system_menu[i].is_selected;
                } else {
                    this.system_menu[i].is_selected = false;
                }
            }
        },
        goto_link : function(menu) {
            let menu_link = this.link_prefix() + menu.link;
            if(menu.children.length==0 && menu.link) {
                location.href = menu_link;
            }
        },
    },
    
    beforeMount() {
        this.leftMenu_click(window.location.pathname);
    },
}
</script>

<style>
.q-item__section--avatar {
    min-width: 40px;
}
.q-expansion-item.active {
    background-color:#333;
}
.q-expansion-item.left_menu > .q-expansion-item__container > .q-item {
    min-height:36px;
}
</style>
